module.exports = __webpack_public_path__ + "static/img/weixuanzhongwenzi.png@2x(1).0e9109dc.png";